/** Vertex/Gemini placeholder when the graph advances without visitor text. */
export const VERTEX_EMPTY_USER_PLACEHOLDER =
  /^\(No user message\. Follow the system instructions\.\)$/i;

const RELEVANT_CONTEXT_SUFFIX = /\n\n\[RELEVANT CONTEXT - USE THIS ACTIVELY:[\s\S]*$/i;

/** Entire line is synthetic — not typed or spoken by the visitor. */
const INTERNAL_ONLY_USER_PATTERNS = [
  VERTEX_EMPTY_USER_PLACEHOLDER,
  /^User has been silent for 60 seconds/i,
  /^You are continuing a conversation with a visitor/i,
  /^The conversation with the visitor is ending now/i,
  /^Η συνομιλία με τον επισκέπτη τελειώνει τώρα/i,
  /^\[System:/i,
];

function isInternalOnlyVisitorLine(text) {
  const s = String(text ?? '').trim();
  if (!s) return true;
  if (s.startsWith('__')) return true;
  return INTERNAL_ONLY_USER_PATTERNS.some((pattern) => pattern.test(s));
}

/**
 * Visitor text safe to show in the chat UI: strips RAG/context suffixes and drops synthetic lines.
 * Returns null when nothing should be displayed.
 */
export function sanitizeVisitorMessageForDisplay(content) {
  let text = String(content ?? '').trim();
  if (!text || isInternalOnlyVisitorLine(text)) return null;

  text = text.replace(RELEVANT_CONTEXT_SUFFIX, '').trim();
  if (!text || isInternalOnlyVisitorLine(text)) return null;

  return text;
}

export function isDisplayableVisitorMessage(content) {
  return sanitizeVisitorMessageForDisplay(content) != null;
}

/** Sanitize user rows for transcript restore / render; drops non-displayable user bubbles. */
export function sanitizeMessagesForDisplay(messages) {
  if (!Array.isArray(messages)) return [];
  return messages.flatMap((message) => {
    if (message?.type !== 'user') return [message];
    const display = sanitizeVisitorMessageForDisplay(message.content);
    if (!display) return [];
    const normalized = String(message.content ?? '').trim();
    if (display === normalized) return [message];
    return [{ ...message, content: display }];
  });
}
